import { render, staticRenderFns } from "./Fatie.vue?vue&type=template&id=0709f71e&scoped=true&"
import script from "./Fatie.vue?vue&type=script&lang=js&"
export * from "./Fatie.vue?vue&type=script&lang=js&"
import style0 from "./Fatie.vue?vue&type=style&index=0&id=0709f71e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709f71e",
  null
  
)

export default component.exports